// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1s9X7","header":"ReportDetails_header__2DhWS","title":"ReportDetails_title__1WUFa","left":"ReportDetails_left__7KwkL"};